import { render } from "./Taxes.vue?vue&type=template&id=c124a7c4&scoped=true"
import script from "./Taxes.vue?vue&type=script&lang=js"
export * from "./Taxes.vue?vue&type=script&lang=js"

import "./Taxes.vue?vue&type=style&index=0&id=c124a7c4&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c124a7c4"]])

export default __exports__